import { render, staticRenderFns } from "./AvatarGroup.vue?vue&type=template&id=42fe0a56"
import script from "./AvatarGroup.vue?vue&type=script&lang=js"
export * from "./AvatarGroup.vue?vue&type=script&lang=js"
import style0 from "./AvatarGroup.vue?vue&type=style&index=0&id=42fe0a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports